var map = {
	"./en.png": "d615",
	"./ja.png": "129b",
	"./km.png": "2c04",
	"./ko.png": "2c0b",
	"./lo.png": "097e",
	"./vi.png": "2e0c",
	"./zh.png": "91bb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61f4";